<template>
  <section class="header-title">
    <div class="container">
      <div class="row">
        <div class="col-md-10">
          <h1>
            Etudiants, Pieter van Naeltwijck service et ISBA TP vous proposent
            un logement à loyer modéré
          </h1>
        </div>
        <div class="col-md-2">
          <img
            class="img-fluid"
            src="/images/"
            alt="logo Pieter van Naeltwijck"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p class="mb-0">
            à partir de 350€/mois en famille d'accueil ou en logement
            individuel.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "headertitle",
  props: {},
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.header-title {
  padding: 30px 0;
  background-image: url(/images/fond.png);
  background-size: cover;
  h1 {
    color: #09b5d7;
    font-size: 2.3rem;
  }
  p {
    color: #fff;
    font-size: 1.8rem;
  }
}
</style>
